// extracted by mini-css-extract-plugin
export default {"inputWrapper":"CustomCheckbox_inputWrapper__XdQ18"};